import type { PropsWithChildren } from 'react';

import Accordion from '~/components/Accordion';
import { useWebThemeContext } from '~/components/Layout/Context/useWebThemeContext';
import Typography from '~/components/Typography';
import type { NavGroup } from '~/interfaces/publication';

type Props = PropsWithChildren<{
  navGroup: NavGroup;
}>;

const DropdownAccordion = ({ navGroup, children }: Props) => {
  const { webTheme: theme } = useWebThemeContext();

  return (
    <Accordion
      className="py-2 pl-6 pr-4"
      iconColor={theme.navbar_text_color}
      titleChildren={
        <div className="flex items-center pt-0.5">
          <Typography
            as="span"
            className=""
            color={theme.navbar_text_color}
            weight="medium"
            fontFamilyv2={theme.navbar_font_family}
            size="sm"
          >
            {navGroup.title}
          </Typography>
        </div>
      }
    >
      <div className="pl-4">{children}</div>
    </Accordion>
  );
};

export default DropdownAccordion;
